import { isPlatformServer } from '@angular/common';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';

@Component({
  selector: 'app-attendee-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class AttendeeCardComponent implements AfterContentInit, AfterViewInit {
  @ContentChild('imageOverlayContent') public imageOverlayContent: ElementRef;

  @ContentChild('topRightContent') public topRightContent: ElementRef;

  @Input() public imageSrc: string;
  @Input() public showImageOverlay = false;
  @Input() public subtitle: string;
  @Input() public title: string;
  @Input() public toptitle: string;
  @Input() public organizationName: string;

  public hasTopRightContent: boolean;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: string) {}

  public ngAfterContentInit(): void {
    this.hasTopRightContent = Boolean(this.topRightContent);
  }

  public ngAfterViewInit(): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
  }
}
